import React from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';
import './externalContent.css';

export default function ExternalContent({ children, label = 'Contenuto esterno', className = '', video = false }) {
  const { preferences, openPreferences, savePreferences } = useCookieConsent();
  if (preferences.externalContent) return <>{children}</>;
  return (
    <div className={`external-content-placeholder ${className}`} role="group" aria-label={label}>
      <p>{video ? 'Accetta i cookie per visualizzare il video' : `${label} non caricato. Per visualizzarlo, abilita i contenuti esterni nelle preferenze cookie.`}</p>
      <button type="button" className="btn btn-outline-primary" onClick={video ? () => savePreferences({ ...preferences, externalContent: true }) : openPreferences}>
        {video ? 'Accetta ora' : 'Apri preferenze cookie'}
      </button>
    </div>
  );
}

function isRemoteImage(src) {
  if (!src || /^(blob:|data:)/i.test(src)) return false;
  try {
    return new URL(src, window.location.href).origin !== window.location.origin;
  } catch {
    return true;
  }
}

export function ExternalImage({ src, srcSet, alt = '', className, ...props }) {
  const remote = isRemoteImage(src) || (srcSet && srcSet.split(',').some((candidate) => isRemoteImage(candidate.trim().split(/\s+/)[0])));
  const image = <img src={src} srcSet={srcSet} alt={alt} className={className} {...props} />;
  return remote ? <ExternalContent label={alt ? `Immagine: ${alt}` : 'Immagine esterna'} className={className}>{image}</ExternalContent> : image;
}
